class LotteryController {
    private LOTTERY_AREA_DEG = [30, 90, 150, 210, 270, 330]
    private BASE_TIME: number = 6500             // 转盘旋转的时间
    private BASE_ROTATE: number = 10             // 转盘旋转圈数
    private startRotateDegree: number = 0        // 上一次旋转结束的角度
    private turntableId: string                  // 转盘id
    private rotateDeg: number = 0                // 转盘需要转到的角度

    constructor(turntableId) {
        this.turntableId = turntableId
    }

    /**
     * 执行抽奖
     */
    public doLottery = (giftIndex: number) => {
        const ele = document.getElementById(this.turntableId)
        this.calcNextRotateDegree(giftIndex)
        ele.style.transition = `all ${this.BASE_TIME}ms`
        ele.style.transform = `rotate(${this.rotateDeg + 360 * this.BASE_ROTATE}deg)`
        this.setStartRotateDegree(this.rotateDeg + 360 * this.BASE_ROTATE)
    }

    public setStartRotateDegree = (degree: number) => {
        this.startRotateDegree = degree
    }

    /**
     * 计算本次中奖要转到的角度
     * @param giftIndex 中奖的奖品序号
     */
    private calcNextRotateDegree = (giftIndex: number) => {
        const rotate = this.LOTTERY_AREA_DEG[giftIndex]
        let i = 0
        const _fn = (n: number = 0) => {
            if (rotate + 360 * n > this.startRotateDegree) {
                this.rotateDeg = rotate + 360 * n
            } else {
                i++
                _fn(i)
            }
        }
        _fn()
    }
}
export default LotteryController
